export type Category =
  | "POWER_TOOLS"
  | "HAND_TOOLS"
  | "ELECTRICAL_SUPPLIES"
  | "SAFETY_EQUIPMENT"
  | "HARDWARE"
  | "LIGHTING"
  | "PLUMBING"
  | "PAINTS_AND_CHEMICALS"
  | "GENERATORS";

export const CATEGORY_NAV_ITEMS: { label: string; value: Category | "NEW_IN" | "MADE_IN_CHINA" | "DISCOVER" }[] = [
  { label: "New In", value: "NEW_IN" },
  { label: "Power Tools", value: "POWER_TOOLS" },
  { label: "Hand Tools", value: "HAND_TOOLS" },
  { label: "Electrical Supplies", value: "ELECTRICAL_SUPPLIES" },
  { label: "Safety Equipment", value: "SAFETY_EQUIPMENT" },
  { label: "Hardware", value: "HARDWARE" },
  { label: "Lighting", value: "LIGHTING" },
  { label: "Plumbing", value: "PLUMBING" },
  { label: "Paints & Chemicals", value: "PAINTS_AND_CHEMICALS" },
  { label: "Generators", value: "GENERATORS" },
  { label: "Made in China", value: "MADE_IN_CHINA" },
  { label: "Discover", value: "DISCOVER" },
];

export interface ProductImage {
  id: string;
  url: string;
  altText?: string | null;
  sortOrder: number;
}

export interface ProductSpec {
  id: string;
  label: string;
  value: string;
}

export interface ProductVariant {
  id: string;
  name: string;
  sku: string;
  priceOverride?: string | null;
  stockQuantity: number;
}

export interface Brand {
  id: string;
  name: string;
  slug: string;
  logoUrl: string;
}

export interface Product {
  id: string;
  name: string;
  slug: string;
  description: string;
  shortDescription?: string | null;
  price: string;
  compareAtPrice?: string | null;
  costPrice?: string | null;
  sku: string;
  stockQuantity: number;
  categories: Category[];
  madeInChina: boolean;
  isNew: boolean;
  isFeatured: boolean;
  brand?: Brand | null;
  images: ProductImage[];
  specifications?: ProductSpec[];
  variants?: ProductVariant[];
}

export type OrderStatus = "PENDING" | "CONFIRMED" | "SHIPPED" | "DELIVERED" | "CANCELLED";
export type PaymentMethod = "MPESA" | "CARD" | "COD";
export type PaymentStatus = "UNPAID" | "PAID" | "FAILED" | "REFUNDED";

export interface Address {
  id: string;
  label: string;
  fullName: string;
  phone: string;
  country: string;
  county?: string | null;
  ward?: string | null;
  city?: string | null;
  street: string;
  postalCode?: string | null;
  isDefault: boolean;
}

export interface OrderItem {
  id: string;
  productId: string;
  productName: string;
  unitPrice: string;
  quantity: number;
}

export interface Order {
  id: string;
  orderNumber: string;
  userId: string;
  user?: { fullName: string; email: string };
  address?: Address | null;
  items: OrderItem[];
  subtotal: string;
  vat: string;
  shippingFee: string;
  total: string;
  status: OrderStatus;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  createdAt: string;
  statusHistory?: { id: string; status: OrderStatus; note?: string | null; createdAt: string }[];
}

export interface Banner {
  id: string;
  imageUrl: string;
  headline: string;
  subtext?: string | null;
  ctaText: string;
  ctaLink: string;
  sortOrder: number;
  isActive: boolean;
}

export interface Testimonial {
  id: string;
  authorName: string;
  authorRole?: string | null;
  photoUrl?: string | null;
  rating: number;
  body: string;
}

export interface Customer {
  id: string;
  fullName: string;
  email: string;
  phone?: string | null;
  role: "CONSUMER" | "AGENT";
  createdAt: string;
  _count?: { orders: number };
}